// removed by extract-text-webpack-plugin
module.exports = {"list":"src-components-about----IndexAbout-module---list---3ZgDs"};


//////////////////
// WEBPACK FOOTER
// ./src/components/about/IndexAbout.module.css
// module id = 429
// module chunks = 168707334958949